import { SVGProps } from 'react';
const SvgCalendarDays = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16 16h.002v.002H16V16ZM12 16h.002v.002H12V16ZM8 16h.002v.002H8V16ZM16 12h.002v.002H16V12ZM12 12h.002v.002H12V12ZM8 12h.002v.002H8V12ZM4 8h16M16 2v2M8 2v2"
    />
  </svg>
);
export default SvgCalendarDays;
